import {
  SAVE_SETTINGS_REQUEST,
  SAVE_SETTINGS_FAILURE,
} from 'app/common/actions/settings/save';

import {
  SETTINGS_SUCCESS,
} from 'app/common/actions/settings/load';
import * as apps from 'app/common/constants/services';

const defaultState = {
  [apps.APP_DNEVNIK]: true,
  [apps.APP_CAFETERIA]: true,
  [apps.APP_ACCESS]: true,
  [apps.APP_POLLS]: true,
  [apps.EXT_YACLASS]: false,
};

export default function reducer(state = defaultState, action) {
  if ((action.type === SAVE_SETTINGS_REQUEST || action.type === SAVE_SETTINGS_FAILURE)
    && action.payload.key
    && action.payload.key === 'fav') {
    return { ...state, ...action.payload.obj };
  }
  if (action.type === SETTINGS_SUCCESS && action.payload.fav) {
    return { ...action.payload.fav };
  }

  return state;
}
